import React from "react";
import logo from '../../assets/logo/logo.png';
import getIcon from "../../utils/Icon";

export default function Avatar({ width, height , label ,icon }) {
    return (
        <div style={{ width: `${width}px`, height: `${height}px` }} className={`${label && 'relative'}`}>
            <img src={icon ? icon : logo} alt="Logo" className="w-full h-full rounded-full object-cover" />
            {
                label && <img src={getIcon(label)} className={'absolute bottom-0 right-0 bg-black bg-white rounded-full w-[35%] h-[35%] object-cover'}/>
            }
        </div>
    );
}
